import { render, staticRenderFns } from "./JjTextTooltip.vue?vue&type=template&id=29657bb6&scoped=true"
import script from "./JjTextTooltip.vue?vue&type=script&lang=js"
export * from "./JjTextTooltip.vue?vue&type=script&lang=js"
import style0 from "./JjTextTooltip.vue?vue&type=style&index=0&id=29657bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29657bb6",
  null
  
)

export default component.exports